export enum LeasingOffersPathsEnum {
  leasingOffers = '/leasing-offers',
}
